import { Component, OnInit, inject } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { BaseComponent } from './base.component';
import { interval, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

/**
 * Example component demonstrating the usage of BaseComponent for memory management.
 * This component shows how to properly handle subscriptions to prevent memory leaks.
 */
@Component({
  selector: 'app-example',
  standalone: true,
  imports: [JsonPipe],
  template: `
    <div>
      <h2>Memory Management Example</h2>
      <p>Counter: {{ counter }}</p>
      <p>Data: {{ data | json }}</p>
      <button (click)="loadData()">Load Data</button>
    </div>
  `
})
export class ExampleComponent extends BaseComponent implements OnInit {
  private http = inject(HttpClient);

  counter = 0;
  data: any = null;

  ngOnInit() {
    // Example 1: Long-lived subscription using subscribeUntilDestroy
    this.subscribeUntilDestroy(interval(1000))
      .subscribe(() => {
        this.counter++;
        console.log(`Counter: ${this.counter}`);
        this.cdr.markForCheck();
      });

    // Example 2: Multiple subscriptions
    this.setupMultipleSubscriptions();
  }

  /**
   * Example of setting up multiple subscriptions that will be automatically
   * unsubscribed when the component is destroyed.
   */
  private setupMultipleSubscriptions() {
    // First subscription
    this.subscribeUntilDestroy(interval(2000))
      .subscribe(() => {
        console.log('First interval fired');
      });

    // Second subscription
    this.subscribeUntilDestroy(interval(3000))
      .subscribe(() => {
        console.log('Second interval fired');
      });
  }

  /**
   * Example of loading data from an HTTP request.
   * Note: HTTP requests complete automatically, so subscribeUntilDestroy is not strictly
   * necessary, but it's still a good practice for consistency.
   */
  loadData() {
    this.subscribeUntilDestroy(this.getData())
      .subscribe(data => {
        this.data = data;
        this.cdr.markForCheck();
      });
  }

  /**
   * Example of a method that returns an Observable.
   * In a real application, this would typically be in a service.
   */
  private getData(): Observable<any> {
    return this.http.get('https://jsonplaceholder.typicode.com/todos/1');
  }

  /**
   * Example of overriding ngOnDestroy to add custom cleanup logic
   * while still calling super.ngOnDestroy() to ensure proper cleanup.
   */
  override ngOnDestroy() {
    console.log('ExampleComponent is being destroyed');

    // Add any custom cleanup logic here

    // Always call super.ngOnDestroy() to ensure proper cleanup
    super.ngOnDestroy();
  }
}
